import { setupLazyLoad } from './lazy-load.ts';
import { setupStopReferrerHack } from './stop-referrer-hack.ts';
import { setupToggles } from './toggles.ts';
import { setupHiddenLinkText } from './hidden-link-text.ts';

export function setup() {
  setupStopReferrerHack();
  setupToggles();
  setupLazyLoad();
  setupHiddenLinkText();
}